import {
  deserify,
  getFileTypeName,
  IconWrapper,
  ImageWrapper,
  InputFieldContainer,
  IStyles,
  PrimaryButton,
  pxToRem,
  pxTovW,
  ScoreProgressBarLinear,
  theme,
} from '@geneo2-web/shared-ui';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import {
  Box,
  Button,
  Divider,
  Modal,
  Slide,
  SxProps,
  TextField,
  Typography,
  useMediaQuery,
} from '@mui/material';
import { useDownloadContext } from '../../../../app/Context/DownloadContextProviderV2';
import { interactionEvent } from '../../../Auth/auth.events';
import {
  ChangeEvent,
  Dispatch,
  ReactNode,
  SetStateAction,
  useRef,
  useState,
} from 'react';
import { useLocation } from 'react-router-dom';
import {
  useAppDispatch,
  useAppSelector,
} from 'apps/teacher/src/reduxStore/reduxHooks';
import { setToastInfo } from 'apps/teacher/src/pages/Auth/reducer/auth.slice';
import { CustomUploadFileResponse } from '../../reducer/assessmentFlow.slice';
import { UploadedFile } from './UploadedFile';
import { UploadSuccessCard } from './UploadSuccessCard';
import DoneIcon from '@mui/icons-material/Done';
import { IUploadStatusMessage, UploadErrorCard } from './UploadErrorCard';
import { Upload } from '@mui/icons-material';
import { UploadValidationError } from '@protos/content_management/cms.teacher.questions.apis_pb';
import { setToastInfoV2 } from '../../../Home/reducer/homeDashboard.slice';

const styles: IStyles = {
  root: {},
  iconBox: {
    height: { xs: pxToRem(113), md: pxTovW(143) },
    display: 'flex',
    width: { xs: pxToRem(113), md: pxTovW(143) },
    borderRadius: '50%',
    backgroundColor: 'rgba(255, 255, 255, 1)',
    boxSizing: 'border-box',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'absolute',
    transform: 'translateY(-50%)',
  },
  actionPopupText: {
    margin: {
      xs: '30% auto 20px auto',
      md: `auto auto ${pxTovW(20)} auto`,
    },
    textAlign: 'center',
    //   alignSelf: 'flex-end',
    height: 'max-content',
    width: { xs: '90%', md: pxTovW(388) },
  },
  actionPopupTextSmall: {
    margin: {
      xs: `${pxToRem(60)} auto 0 auto`,
      md: `${pxTovW(92)} auto 0 auto`,
    },
    textAlign: 'center',
    //   alignSelf: 'flex-end',
    height: '100%',
    width: { xs: '90%', md: pxTovW(388) },
  },
  resolveButton: {
    padding: {
      xs: `${pxToRem(14)} ${pxToRem(20)}`,
      md: `${pxTovW(16)} ${pxTovW(32)}`,
    },
    backgroundColor: '#0AA34F',
    borderRadius: { xs: pxToRem(8), md: pxTovW(8) },
    '&:hover': {
      backgroundColor: '#089640',
    },
    margin: 'auto',
    textTransform: 'uppercase',
  },
};

interface IProps {
  open: boolean;
  handleClose: () => void;
  instructions: string[];
  downloadClickHandler?: () => void;
  templateDownloading?: boolean;
  FileUploading: boolean;
  handleChangeFunction: (event: ChangeEvent<HTMLInputElement>) => void;
  userUploadedFile: CustomUploadFileResponse | undefined;
  uploadStatusMessage?: IUploadStatusMessage;
  setUploadStatusMessage: Dispatch<SetStateAction<IUploadStatusMessage>>;
  retryUploadFunction: () => void;
}
export const AddQuestionsPopup = (props: IProps) => {
  const {
    open,
    handleClose,
    instructions,
    downloadClickHandler,
    templateDownloading,
    FileUploading,
    handleChangeFunction,
    userUploadedFile,
    uploadStatusMessage,
    retryUploadFunction,
  } = props;
  const dispatch = useAppDispatch();
  const inputRef = useRef<HTMLInputElement | null>(null);
  const tempFileUploadPercentage = 0;
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const validateFileType = (file: File) => {
    const allowedTypes = [
      'application/vnd.ms-excel',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    ];
    return allowedTypes.includes(file.type);
  };

  const handleChange = async (event: ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (files && files.length > 0) {
      const file = files[0];
      if (validateFileType(file)) {
        await handleChangeFunction(event);
      } else {
        dispatch(
          setToastInfoV2({
            label: 'Only Excel files are allowed.',
            variant: 'error',
            open: true,
          })
        );
      }
    }
  };
  return (
    <Modal
      open={open}
      onClose={() => {
        handleClose();
      }}
    >
      <Slide direction="up" in={open} mountOnEnter unmountOnExit timeout={500}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            width: '100vw',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              boxSizing: 'border-box',
              // mt: { xs: '18%', md: '10%' },
              padding: { xs: pxToRem(10), md: pxTovW(20) },
              gap: { xs: pxToRem(30), md: pxTovW(20) },
              flexDirection: { xs: 'column', md: 'row' },
              alignItems: { xs: 'center', md: 'flex-start' },
              width: { xs: '95%', md: 'unset' },
            }}
          >
            <Box
              sx={{
                display: 'flex',
                boxSizing: 'border-box',
                flexDirection: 'column',
                justifyContent: 'flex-start',
                alignItems: 'center',
                backgroundColor: 'white',
                width: { xs: '100%', md: pxTovW(741) },
                minHeight: { xs: '60%', md: pxTovW(370) },

                borderRadius: { xs: pxToRem(20), md: pxTovW(20) },
                gap: { xs: pxToRem(10), md: pxTovW(10) },
                paddingX: { xs: pxToRem(20), md: pxTovW(20) },
                paddingY: { xs: pxToRem(15), md: pxTovW(20) },
              }}
            >
              <Box sx={{ width: '100%' }}>
                {
                  <Typography
                    variant="h2"
                    fontWeight={'bold'}
                    sx={{ marginY: { xs: pxToRem(5), md: pxTovW(20) } }}
                  >
                    {userUploadedFile
                      ? userUploadedFile.fileUploadStatus === 'Upload Error'
                        ? `Upload Error`
                        : userUploadedFile.fileUploadStatus === 'success'
                        ? `Upload Complete`
                        : `Uploading Questions`
                      : `Add Your Own Questions`}
                  </Typography>
                }
                <Divider
                  sx={{
                    bgcolor: '#E0E0E0',
                    height: '2px',
                    width: '100%',
                    my: { xs: pxToRem(5), md: pxTovW(5) },
                    opacity: 0.5,
                  }}
                />
              </Box>

              {userUploadedFile?.fileUploadStatus === 'Upload Error' ? (
                <Box
                  sx={{
                    width: '100%',
                    boxSizing: 'border-box',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  {uploadStatusMessage !== undefined ? (
                    <UploadErrorCard statusMessage={uploadStatusMessage} />
                  ) : (
                    <Typography>No error details available.</Typography>
                  )}
                </Box>
              ) : userUploadedFile?.fileUploadStatus === 'success' ? (
                <UploadSuccessCard />
              ) : userUploadedFile ? (
                <Box
                  sx={{
                    display: 'flex',
                    width: '100%',
                    mt: { xs: pxToRem(10), md: pxTovW(20) },
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <UploadedFile
                    file={userUploadedFile}
                    progress={tempFileUploadPercentage}
                  />
                </Box>
              ) : (
                <Box>
                  <Box
                    sx={{
                      width: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'flex-start',
                      gap: { xs: pxToRem(10), md: pxTovW(20) },
                    }}
                  >
                    <Typography
                      variant="h3"
                      fontWeight={'bold'}
                      sx={{ marginY: { xs: pxToRem(5), md: pxTovW(10) } }}
                    >
                      Instructions
                    </Typography>
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: { xs: pxToRem(10), md: pxTovW(20) },
                      }}
                    >
                      {instructions?.map((item, index) => (
                        <Box
                          key={index}
                          sx={{
                            display: 'flex',
                            justifyContent: 'flex-start',
                            gap: { xs: pxToRem(10), md: pxTovW(20) },
                          }}
                        >
                          <DoneIcon
                            sx={{
                              color: '#007CDC',
                              fontSize: {
                                xs: pxToRem(16),
                                md: pxToRem(22),
                              },

                              fontWeight: 'bold',
                            }}
                          />
                          <Typography
                            variant="h4"
                            // fontWeight="medium"
                          >
                            {item}{' '}
                          </Typography>
                        </Box>
                      ))}
                    </Box>
                  </Box>

                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'center',
                      mt: { xs: pxToRem(10), md: pxTovW(20) },
                      gap: { xs: pxToRem(10), md: pxTovW(20) },
                    }}
                  >
                    <input
                      type="file"
                      multiple
                      hidden
                      ref={inputRef}
                      onChange={handleChange}
                    />
                    <PrimaryButton
                      variant="outlined"
                      disabled={templateDownloading}
                      onClick={() =>
                        downloadClickHandler && downloadClickHandler()
                      }
                      sx={{
                        width: { xs: '90%', md: pxTovW(263) },
                        // height: { xs: pxToRem(35), md: pxTovW(55) },
                        p: { xs: pxToRem(5), md: pxTovW(5) },
                        border: '1px solid #007CDC',
                        backgroundColor: '#E8F5FF',
                        borderRadius: { xs: pxToRem(5), md: pxTovW(10) },
                        boxSizing: 'border-box',
                        boxShadow: 'none',
                      }}
                    >
                      <Typography
                        variant={isMobile ? 'h4' : 'h3'}
                        fontWeight="medium"
                        color="#007CDC"
                      >
                        Download Template
                      </Typography>
                    </PrimaryButton>

                    <PrimaryButton
                      onClick={() => {
                        if (inputRef.current) inputRef.current.click();
                      }}
                      disabled={FileUploading}
                      sx={{
                        width: { xs: '90%', md: pxTovW(263) },
                        // height: { xs: pxToRem(35), md: pxTovW(55) },
                        p: { xs: pxToRem(5), md: pxTovW(5) },
                        backgroundColor: '#007CDC',
                        borderRadius: { xs: pxToRem(5), md: pxTovW(10) },
                        boxSizing: 'border-box',
                        boxShadow: 'none',
                      }}
                    >
                      <Typography
                        variant={isMobile ? 'h4' : 'h3'}
                        fontWeight="bold"
                        color="#FFFFFF"
                        sx={{ cursor: 'pointer' }}
                      >
                        UPLOAD
                      </Typography>
                    </PrimaryButton>
                  </Box>
                </Box>
              )}
              {userUploadedFile?.fileUploadStatus === 'Upload Error' &&
              uploadStatusMessage !== undefined ? (
                <PrimaryButton
                  onClick={() => {
                    retryUploadFunction();
                  }}
                  sx={styles.resolveButton}
                >
                  <Typography
                    variant={isMobile ? 'h4' : 'h3'}
                    fontWeight="bold"
                    color="white"
                    sx={{ letterSpacing: '0.5px' }}
                  >
                    Resolve Error and Reupload
                  </Typography>
                </PrimaryButton>
              ) : (
                <></>
              )}
            </Box>
            <Button
              onClick={() => {
                handleClose();
              }}
              sx={{ p: '0px' }}
            >
              <IconWrapper
                name="close-yellow"
                size="md"
                parentFolder="icons"
                type="png"
                customSx={{
                  width: { xs: pxToRem(33), md: pxTovW(54) },
                  height: { xs: pxToRem(33), md: pxTovW(54) },
                }}
              />
            </Button>
          </Box>
        </Box>
      </Slide>
    </Modal>
  );
};
